import { useContext, useEffect, useRef, useState } from 'react';
import AuthContext from '../../../contexts/auth/AuthContext';
import SelectableContext from '../../../contexts/local/selectable/SelectableContext';
import ProcessContext from '../../../contexts/process/ProcessContext';
import UIContext from '../../../contexts/ui/UIContext';
import StatusBarButton from '../../layout/StatusBarButton';
import Loading from '../../ui-elements/Loading';
import SeedSlotSelectable from '../discarding/tray/SeedSlotSelectable';
import Tray from '../Tray';
import { useNavigate } from 'react-router-dom';
import BackButton from '../../layout/BackButton';
import useConfirm from '../../confirmation/useConfirm';

const EmptyTraySlotSelector = ({ forwardTo, backwardTo, selectedSlots }) => {
  const navigate = useNavigate();

  const { loadOccupancy, occupancyArray, activeProcessId, continueProcess, additionalProcessInformation, backIsAllowed } =
    useContext(ProcessContext);

  const { currentContainer } = useContext(AuthContext);

  const { selection, Sidebar, isSelecting } = useContext(SelectableContext);

  const { loading } = useContext(UIContext);

  const [showContinueButton, setShowContinueButton] = useState(false);

  const hasProcessedRef = useRef(false);

  const { ConfirmDialog } = useConfirm();

  const load = async () => {
    await loadOccupancy(additionalProcessInformation?.destinationEntity, currentContainer?.id);
  };

  useEffect(() => {
    load();
  }, []);

  useEffect(() => {
    if (selection.length > 0 && !isSelecting) {

      setShowContinueButton(true);

    } else if (isSelecting) {
      setShowContinueButton(false);
    }
  }, [selection, isSelecting]);

  useEffect(() => {
    if (!selectedSlots || hasProcessedRef.current) return;

    const automatedProcess = async () => {
      hasProcessedRef.current = true;
      await proceedToSlotSelectionConfirmation();
    };
    automatedProcess();
  }, [selectedSlots])

  const proceedToSlotSelectionConfirmation = async () => {
    try {
      if(selectedSlots && selectedSlots.length > 0){
        const executableSlot = selectedSlots.filter(item => item.executable === true).map(sl => sl.destinationSlot);
        await continueProcess(activeProcessId, executableSlot);
      } else {
        await continueProcess(activeProcessId, selection);
        }


        if (forwardTo) {
          navigate(forwardTo);
        }
        } catch (error) {
        console.error(error);
        }
        };

  const reversedArray = [...occupancyArray].reverse();

  return loading || !occupancyArray?.length   ? (
    <Loading fullScreen />
  ) : (
    <>
      <ConfirmDialog />
      <BackButton disabled={!backIsAllowed} navigateTo={backwardTo} />
      {Sidebar}
      <Tray>
        {occupancyArray &&
          occupancyArray.length > 0 &&
          reversedArray.map((unit) => (
            <SeedSlotSelectable
              key={unit.index}
              processName='planting'
              displayName={!unit.isAvailable ? unit.display : ''}
              index={unit.index}
              selectable={unit.isAvailable}
              isMultiharvestable={unit.isMultiharvestable}
              seedTypeIsMultiharvestable={additionalProcessInformation.isMultiharvestable}
            />
          ))}
      </Tray>
      {showContinueButton && (
        <>
          <StatusBarButton
            label='Continue'
            icon='fas fa-chevron-right'
            reversed={true}
            clickHandler={proceedToSlotSelectionConfirmation}
            statusSlot={5}
          />
        </>
      )}
    </>
  );
};

export default EmptyTraySlotSelector;
